export const CONTENT_TYPE = {
	category: 'category',
	products: 'products',
	banner: 'banner',
};

export const CONTENT_TYPE_LABEL = {
	category: 'Category',
	products: 'Product',
	banner: 'Banner',
};

export const NAVIGATION_MENU_CONTENT_TYPE = {
	menu: 'menu',
	suggestBannerMenuMobile: 'suggest_banner_menu_mobile',
};
